import {busquedaConstants} from '../_constants';
import {buscadorService} from '../_services';
import {history} from '../_helpers';
import alertService from '../_services/cart/alert.service';

export const busquedaActions = {
    filtrarDesdeBusqueda,
    seleccionarProducto,
    buscarYSeleccionarProducto,
    buscarYSeleccionarProductoAdmin,
    buscarYSeleccionarProductoBackOffice,
    traerFiltros,
    traerVersionesDeModelo,
    limpiarProducto
};

function buscarYSeleccionarProducto(id, setLoading) {
    setLoading(true);
    return dispatch => {
        buscadorService.buscarProductoPorId(id)
            .then(
                data => {
                    dispatch(success(data.producto));
                    setLoading(false);
                },
                error => {
                    setLoading(false);

                    /*
                     * Una publicacion dada de baja sigue teniendo su link dando vueltas por
                     * redes y por el historial, asi que el 404 es un caso esperado y no un
                     * error: se avisa y se vuelve al home, que es donde la persona puede
                     * seguir buscando.
                     *
                     * Va aca y no en alertService porque ese solo muestra el cartel cuando el
                     * codigo es 500; sin este caso el 404 quedaba mudo y la ficha en blanco.
                     */
                    if (error && error.codigo === 404) {
                        alertService.error(error.message);
                        history.push("/home");
                        return;
                    }

                    alertService.error(error);
                }
            );
    };

    function success(producto) {
        return {type: busquedaConstants.PRODUCTO_SELECCIONADO, producto: producto}
    }
}


function limpiarProducto(id) {
    return dispatch => {
        dispatch(success());
    };

    function success() {
        return {type: busquedaConstants.LIMPIAR_PRODUCTO}
    }
}

function buscarYSeleccionarProductoAdmin(id) {
    return dispatch => {
        buscadorService.buscarProoductoPorIdAdmin(id)
            .then(
                data => {
                    dispatch(success(data.producto));
                },
                error => {
                    alertService.error(error);
                }
            );
    };

    function success(producto) {
        return {type: busquedaConstants.PRODUCTO_SELECCIONADO, producto: producto}
    }
}

/** Carga por el carril de admin: la publicacion puede ser de cualquier vendedor. */
function buscarYSeleccionarProductoBackOffice(id) {
    return dispatch => {
        buscadorService.buscarProductoPorIdBackOffice(id)
            .then(
                data => {
                    dispatch(success(data.producto));
                },
                error => {
                    alertService.error(error);
                }
            );
    };

    function success(producto) {
        return {type: busquedaConstants.PRODUCTO_SELECCIONADO, producto: producto}
    }
}

function seleccionarProducto(producto) {
    return dispatch => {
        dispatch(success(producto));
    };

    function success(producto) {
        return {type: busquedaConstants.PRODUCTO_SELECCIONADO, producto: producto}
    }
}


function filtrarDesdeBusqueda(option) {
    return dispatch => {
        history.push('/busqueda');
        dispatch(success(option));
    };

    function success(option) {
        return {type: busquedaConstants.BUSCADOR_MAIN_OPTION_SET, option: option}
    }
}

/**
 * Carga las versiones de un modelo y las mete en `filtros.versiones`.
 *
 * Idempotente: si ese modelo ya se pidio no vuelve a pegarle a la API, asi que se puede
 * llamar en cada render sin pensarlo.
 */
function traerVersionesDeModelo(modeloId) {
    return (dispatch, getState) => {
        if (!modeloId) return;

        const filtros = getState().busqueda?.filtros;
        if ((filtros?.modelosConVersionesCargadas || []).includes(modeloId)) return;

        buscadorService.traerVersiones(modeloId)
            .then(
                data => dispatch({
                    type: busquedaConstants.BUSCADOR_VERSIONES_MODELO,
                    modeloId,
                    versiones: data?.versiones || []
                }),
                error => alertService.error(error)
            );
    };
}

function traerFiltros() {
    return dispatch => {
        buscadorService.traerFiltros()
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    alertService.error(error);
                }
            );
    };

    function success(filtros) {
        return {type: busquedaConstants.BUSCADOR_FILTROS, filtros: filtros}
    }
}


